import { render, staticRenderFns } from "./TextAndYoutubeVideo.vue?vue&type=template&id=5aa78677&"
import script from "./TextAndYoutubeVideo.vue?vue&type=script&lang=js&"
export * from "./TextAndYoutubeVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports